import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportRunsApi extends BaseApi {
    constructor(client) { super(client, '/report-runs'); }

    async count(input) {
        try {
            return (await this.client.post(`${this.basePath}/count`, input)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async run(input) {
        try {
            return (await this.client.post(this.basePath, input)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
